import { css } from 'lit';
export const notificationStyles = css `
    :host {
        -webkit-text-size-adjust: none;
    }

    .hlx-overlay {
        z-index: -1;
        position: fixed;
        inset: 0;
        background-color: var(--hlx-overlay-background-color-default);
    }

    .hlx-text-container {
        display: flex;
        flex-direction: column;
        gap: var(--hlx-spacing-xs);
        flex-grow: 1;
    }

    .hlx-close-button {
        padding: 10px;
        top: -10px;
        position: relative;
        right: -10px;
    }

    .hlx-close-button,
    .hlx-arrow-button {
        display: flex;
    }

    .hlx-arrow-button {
        margin-left: var(--hlx-spacing-xs);
        /* https://exas.atlassian.net/browse/HLX-122 workaround for Firefox */
        pointer-events: none;
    }

    .hlx-close-button::part(base),
    .hlx-arrow-button::part(base) {
        line-height: normal;
        padding: 0;
        min-height: auto;
        border: none;
    }

    .hlx-close-button::part(icon),
    .hlx-arrow-button::part(icon) {
        width: 14px;
    }

    .hlx-primary-container {
        justify-content: center;
        align-items: flex-start;
        background: var(--hlx-color-warning-default);
        min-width: 100%;
        display: flex;
        gap: var(--hlx-spacing-xs);
        padding: var(--hlx-spacing-md) var(--hlx-spacing-lg);
        color: var(--hlx-text-color-default);
    }

    .hlx-primary-container.expandable {
        cursor: pointer;
    }

    .hlx-primary-title {
        font-family: var(--hlx-text-font-family-sans-serif);
        font-weight: var(--hlx-text-font-weight-semibold);
        font-size: var(--hlx-text-font-size-sm);
        line-height: var(--hlx-text-line-height-default);
        white-space: nowrap;
    }

    .hlx-primary-link {
        display: none;
        width: fit-content;
        white-space: nowrap;
        color: var(--hlx-text-color-default);
        font-size: var(--hlx-text-font-size-sm);
        font-weight: var(--hlx-text-font-weight-medium);
    }

    .hlx-notification-has-primary-link-text .hlx-primary-link {
        display: inline;
    }

    .hlx-primary-link:focus-visible {
        outline: 2px solid var(--hlx-color-brand-default);
        outline-offset: 2px;
    }

    .hlx-primary-description {
        font-family: var(--hlx-text-font-family-sans-serif);
        font-weight: var(--hlx-text-font-weight-medium);
        font-size: var(--hlx-text-font-size-sm);
        line-height: var(--hlx-text-line-height-default);
    }

    .hlx-arrow-icon {
        transition: transform var(--hlx-motion-duration-slow-2) var(--hlx-motion-easing-in-out);
    }

    .hlx-arrow-icon.hlx-expanded {
        transform: rotate(180deg);
    }

    .hlx-secondary-container {
        position: absolute;
        top: 100%;
        width: 100%;
        background: var(--hlx-color-warning-default);
        color: var(--hlx-text-color-default);
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows var(--hlx-motion-duration-slow-1)
            var(--hlx-motion-easing-in-out);
    }

    .hlx-secondary-container-inner {
        overflow: hidden;
    }

    .hlx-secondary-container.hlx-expanded {
        grid-template-rows: 1fr;
        border-top: 1px solid var(--hlx-border-color-default);
    }

    .hlx-secondary-block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: left;
        padding: var(--hlx-spacing-xl) var(--hlx-spacing-lg);
    }

    .hlx-secondary-title {
        display: none;
        margin-bottom: var(--hlx-spacing-xs);
        font-weight: var(--hlx-text-font-weight-semibold);
        font-size: var(--hlx-text-font-size-xl);
        line-height: var(--hlx-text-line-height-tight-3);
    }

    .hlx-notification-has-secondary-title .hlx-secondary-title {
        display: block;
    }

    .hlx-secondary-description {
        font-weight: var(--hlx-text-font-weight-medium);
        font-size: var(--hlx-text-font-size-md);
        line-height: var(--hlx-text-line-height-default);
    }

    .hlx-secondary-button {
        display: none;
        margin-top: var(--hlx-spacing-lg);
    }

    .hlx-notification-has-secondary-button-text .hlx-secondary-button {
        display: inline-block;
    }

    .hlx-close-button {
        margin-left: var(--hlx-spacing-xl);
    }

    @media (min-width: 768px) {
        .hlx-text-container,
        .hlx-primary-container {
            width: 100%;
        }

        .hlx-text-container {
            flex-grow: 0;
        }

        .hlx-primary-container {
            padding: var(--hlx-spacing-md) var(--hlx-spacing-xl);
        }

        .hlx-arrow-button {
            margin-left: 0;
        }

        .hlx-secondary-block {
            padding: var(--hlx-spacing-xl);
        }
    }

    @media (min-width: 1440px) {
        .hlx-text-container {
            flex-direction: row;
            align-items: center;
            width: auto;
        }

        .hlx-primary-container {
            max-width: 1008px;
            align-items: center;
            width: auto;
        }

        .hlx-close-button {
            position: absolute;
            padding: 0;
            top: unset;
            right: var(--hlx-spacing-xl);
            margin-left: 0;
        }

        .hlx-secondary-block {
            max-width: 1008px;
            margin: 0 auto;
            padding: var(--hlx-spacing-xl) 0;
        }

        .hlx-secondary-title {
            font-size: var(--hlx-text-font-size-3xl);
        }
    }
`;
//# sourceMappingURL=notification.styles.js.map